import { Component, OnInit, DoCheck } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { Validators } from "@angular/forms";
import { Location } from "@angular/common";
import { ControlService } from "src/app/services/control/control.service";
import { MessageService } from "primeng/api";
import { ActivatedRoute, Router } from "@angular/router";
import { UserLoginService } from "src/app/services/UserLogin/UserLoginService";
import { EmailService } from "src/app/services/email/emailService";
import { FechasService } from "../../../../services/fechas/fechas";
import { GenericService } from "../../../../services/generic/generic.service";
import { StorageManager } from "src/app/common/storage-manager.class";

@Component({
  selector: "app-control-create-update",
  templateUrl: "./control-create-update.component.html",
  styleUrls: ["./control-create-update.component.css"],
})
export class ControlCreateUpdateComponent implements OnInit, DoCheck {
  public editControlForm: FormGroup;
  public createControlProduct: any = [];
  public myMonth = "";
  public myId: any;
  discriminador: boolean = false;
  public id: string = "";
  public database = "plasticos";

  public user: any;
  public update: boolean;
  public title: string = "";
  public loaderSubmit: boolean = false;

  constructor(
    private location: Location,
    private controlService: ControlService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private usuarioLoginName: UserLoginService,
    private router: Router,
    private emailService: EmailService,
    private _fechaService: FechasService,
    private genericService: GenericService
  ) {
    this.empezar();
  }
  empezar() {
    this.route.params.subscribe((data) => {
      console.log(data);
      this.myId = data.id;

      if (this.myId) {
        this.update = true;
        this.title = "Editar control";
        this.controlService.getIdControl(this.myId).subscribe((resp) => {
          this.iniciar(resp[0]);
        });
      } else {
        this.update = false;
        this.title = "Crear control";
        // this.iniciar(null);
      }
    });
  }

  ngOnInit(): void {
    this.user = StorageManager.getUser();
    this.iniciar(null);
  }

  ngDoCheck() {
    this.cambiarMes();
  }
  comprobar() {
    if (this.discriminador) {
      this.editControlForm.patchValue({
        zona1: false,
        zona2: false,
        zona3: false,
        zona4: false,
        zona5: false,
        zona6: false,
        zona7: false,
        zona8: false,
        zona9: false,
      });
      this.discriminador = false;
    } else {
      this.editControlForm.patchValue({
        zona1: true,
        zona2: true,
        zona3: true,
        zona4: true,
        zona5: true,
        zona6: true,
        zona7: true,
        zona8: true,
        zona9: true,
      });
      this.discriminador = true;
    }
  }

  iniciar(control: any) {
    if (control == null) {
      this.editControlForm = new FormGroup({
        id: new FormControl(""),
        fecha: new FormControl(this.fecha(), Validators.required),
        mes: new FormControl(""),
        zona1: new FormControl(true),
        zona2: new FormControl(true),
        zona3: new FormControl(true),
        zona4: new FormControl(true),
        zona5: new FormControl(true),
        zona6: new FormControl(true),
        zona7: new FormControl(true),
        zona8: new FormControl(true),
        zona9: new FormControl(true),
        zona_obs: new FormControl(""),
        automatica1: new FormControl(false),
        automatica2: new FormControl(false),
        automatica3: new FormControl(false),
        automatica4: new FormControl(false),
        automatica_obs: new FormControl(""),
        malla1: new FormControl(false),
        malla2: new FormControl(false),
        malla3: new FormControl(false),
        malla_obs: new FormControl(""),
        presecado: new FormControl(false),
        secado: new FormControl(false),
        tuneles_obs: new FormControl(""),
        maquina1: new FormControl(false),
        maquina_obs: new FormControl(""),
        maquina7: new FormControl(false),
        maquina8: new FormControl(false),
        maquina9: new FormControl(false),
        elevadoras_obs: new FormControl(""),
        camara1: new FormControl(false),
        camara2: new FormControl(false),
        camara3: new FormControl(false),
        camara4: new FormControl(false),
        camaras_obs: new FormControl(""),
        garita_entradas: new FormControl(false),
        garita_central: new FormControl(false),
        garita_salidas: new FormControl(false),
        garitas_obs: new FormControl(""),
        garita_entradas_carton: new FormControl(false),
        garita_central_carton: new FormControl(false),
        garita_salidas_carton: new FormControl(false),
        garitas_carton_obs: new FormControl(""),
        carretes_pequenos: new FormControl(false),
        carretes_grandes: new FormControl(false),
        carretes_obs: new FormControl(""),
        fechaoperario: new FormControl(""),
        nombreoperario: new FormControl(""),
        todos: new FormControl(""),
        revisado_fecha: new FormControl(""),
        revisado_nombre: new FormControl(this.user.name),
        observaciones: new FormControl(""),
      });
    } else {
      this.editControlForm = new FormGroup({
        id: new FormControl(this.myId),
        fecha: new FormControl(control.fecha, Validators.required),
        mes: new FormControl(this.myMonth),
        todos: new FormControl(control.todos),
        zona1: new FormControl(control.zona1),
        zona2: new FormControl(control.zona2),
        zona3: new FormControl(control.zona3),
        zona4: new FormControl(control.zona4),
        zona5: new FormControl(control.zona5),
        zona6: new FormControl(control.zona6),
        zona7: new FormControl(control.zona7),
        zona8: new FormControl(control.zona8),
        zona9: new FormControl(control.zona9),
        zona_obs: new FormControl(control.zona_obs),
        automatica1: new FormControl(control.automatica1),
        automatica2: new FormControl(control.automatica2),
        automatica3: new FormControl(control.automatica3),
        automatica4: new FormControl(control.automatica4),
        automatica_obs: new FormControl(control.automatica_obs),
        malla1: new FormControl(control.malla1),
        malla2: new FormControl(control.malla2),
        malla3: new FormControl(control.malla3),
        malla_obs: new FormControl(control.malla_obs),
        presecado: new FormControl(control.presecado),
        secado: new FormControl(control.secado),
        tuneles_obs: new FormControl(control.tuneles_obs),
        maquina1: new FormControl(control.maquina1),
        maquina_obs: new FormControl(control.maquina_obs),
        maquina7: new FormControl(control.maquina7),
        maquina8: new FormControl(control.maquina8),
        maquina9: new FormControl(control.maquina9),
        elevadoras_obs: new FormControl(control.elevadoras_obs),
        camara1: new FormControl(control.camara1),
        camara2: new FormControl(control.camara2),
        camara3: new FormControl(control.camara3),
        camara4: new FormControl(control.camara4),
        camaras_obs: new FormControl(control.camaras_obs),
        garita_entradas: new FormControl(control.garita_entradas),
        garita_central: new FormControl(control.garita_central),
        garita_salidas: new FormControl(control.garita_salidas),
        garitas_obs: new FormControl(control.garitas_obs),
        garita_entradas_carton: new FormControl(control.garita_entradas_carton),
        garita_central_carton: new FormControl(control.garita_central_carton),
        garita_salidas_carton: new FormControl(control.garita_salidas_carton),
        garitas_carton_obs: new FormControl(control.garitas_carton_obs),
        carretes_pequenos: new FormControl(control.carretes_pequenos),
        carretes_grandes: new FormControl(control.carretes_grandes),
        carretes_obs: new FormControl(control.carretes_obs),
        fechaoperario: new FormControl(control.fechaoperario),
        nombreoperario: new FormControl(control.nombreoperario),
        revisado_fecha: new FormControl(control.revisado_fecha),
        revisado_nombre: new FormControl(control.revisado_nombre),
        observaciones: new FormControl(control.observaciones),
      });
    }
  }
  onSubmit() {
    this.loaderSubmit = true;

    let data = [{}];
    data[0]["id"] = this.id || "0";

    for (const key in this.editControlForm.value) {
      data[0][key] = this.editControlForm.value[key];
    }

    data[0]["fecha"] = this._fechaService.arreglarFecha(
      this.editControlForm.get("fecha").value
    );
    if (this.update) {
      this.genericService
        .update(data[0], this.database)
        .toPromise()
        .then(
          (resp: any) => {
            //this.controlService.updateControl(this.editControlForm.value).subscribe(resp=>{
            // console.log(this.editControlForm.value);
            this.messageService.add({
              severity: "success",
              summary: "Actualizado correctamente",
              detail: `Registro ${this.database} actualizado`,
            });
            //this.empezar();
            let observaciones: string =
              this.editControlForm.controls.observaciones.value;
            if (
              observaciones === null ||
              observaciones === undefined ||
              observaciones.length == 0
            ) {
            } else {
              this.emailService
                .sendMessage(
                  this.editControlForm.value,
                  "CONTROL DE CRISTALES, PLÁSTICOS, LUCES Y METALES"
                )
                .toPromise()
                .then((data) => {
                  // console.log('data', data);
                })
                .catch((error) => {
                  console.log("error message", error);
                });
            }
            this.router.navigate(["dashboard/control"]);
          },
          (error) => {
            console.log("Error", error);
            this.messageService.add({
              severity: "success",
              summary: "Actualizado erróneamente",
              detail: `Error en registro ${error}`,
            });
            this.messageService.add({
              severity: "error",
              summary: "Resgistro",
              detail: "Error en el registro " + error + "",
            });
          }
        );
    } else {
      console.log(data[0])
      this.genericService
        .create(data[0], this.database)
        .toPromise()
        .then(
          (resp: any) => {
            //this.controlService.createControl(this.createControlForm.value).subscribe( resp => {
            // console.log(resp);
            // resp = data[0];
            this.messageService.add({
              severity: "success",
              summary: "Añadido correctamente",
              detail: `Registro ${this.database} añadido`,
            });
            let observaciones: string =
              this.editControlForm.get("observaciones").value; //  .controls.observaciones.value;
            if (
              observaciones === null ||
              observaciones === undefined ||
              observaciones.length == 0
            ) {
            } else {
              this.emailService
                .sendMessage(
                  this.editControlForm.value,
                  "CONTROL DE CRISTALES, PLÁSTICOS, LUCES Y METALES"
                )
                .toPromise()
                .then((data) => {
                  // console.log('data', data);
                })
                .catch((error) => {
                  console.log("error message", error);
                });
            }
            // setTimeout(
            //   function () {
            //     this.router.navigate(["dashboard/control"]);
            //   }.bind(this),
            //   1000
            // );
            this.router.navigate(["dashboard/control"]);
          },
          (error) => {
            console.log(error);
            this.messageService.add({
              severity: "success",
              summary: "Añadido erróneamente",
              detail: `Error en registro ${error}`,
            });
          }
        );
    }
  }
  cambiarMes() {
    let fecha = this.editControlForm.controls.fecha.value;

    let posiciones = fecha.split("-");
    this.myMonth = this.seleccionarMes(parseInt(posiciones[1]));

    this.editControlForm.patchValue({
      mes: this.myMonth,
    });
  }
  seleccionarMes(mes) {
    let month = "";
    switch (mes) {
      case 1:
        month = "Enero";
        break;
      case 2:
        month = "Febrero";
        break;
      case 3:
        month = "Marzo";
        break;
      case 4:
        month = "Abril";
        break;
      case 5:
        month = "Mayo";
        break;
      case 6:
        month = "Junio";
        break;
      case 7:
        month = "Julio";
        break;
      case 8:
        month = "Agosto";
        break;
      case 9:
        month = "Septiembre";
        break;
      case 10:
        month = "Octubre";
        break;
      case 11:
        month = "Noviembre";
        break;
      case 12:
        month = "Diciembre";
        break;
      default:
    }
    return month;
  }
  fecha() {
    let today = new Date();
    let dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();
    let DD = "";
    let MM = "";
    if (dd < 10) {
      DD = "0" + dd;
    } else {
      DD = "" + dd;
    }

    if (mm < 10) {
      MM = "0" + mm;
    } else {
      MM = "" + mm;
    }

    let myfecha = MM + "/" + DD + "/" + yyyy;
    myfecha = yyyy + "-" + MM + "-" + DD;
    return myfecha;
  }

  regresar() {
    this.location.back();
  }

  comprobarElevadoras(value) {
    if (value.checked) {
      this.editControlForm.patchValue({
        maquina7: true,
        maquina8: true,
        maquina9: true,
      });
    } else {
      this.editControlForm.patchValue({
        maquina7: false,
        maquina8: false,
        maquina9: false,
      });
    }
  }

  comprobarEnmalladoras(value) {
    if (value.checked) {
      this.editControlForm.patchValue({
        malla1: true,
        malla2: true,
        malla3: true,
      });
    } else {
      this.editControlForm.patchValue({
        malla1: false,
        malla2: false,
        malla3: false,
      });
    }
  }
  comprobarGaritas(value) {
    if (value.checked) {
      this.editControlForm.patchValue({
        garita_entradas: true,
        garita_central: true,
        garita_salidas: true,
      });
    } else {
      this.editControlForm.patchValue({
        garita_entradas: false,
        garita_central: false,
        garita_salidas: false,
      });
    }
  }
  comprobarCarton(value) {
    if (value.checked) {
      this.editControlForm.patchValue({
        garita_entradas_carton: true,
        garita_central_carton: true,
        garita_salidas_carton: true,
      });
    } else {
      this.editControlForm.patchValue({
        garita_entradas_carton: false,
        garita_central_carton: false,
        garita_salidas_carton: false,
      });
    }
  }
  comprobarTuneles(value) {
    if (value.checked) {
      this.editControlForm.patchValue({
        presecado: true,
        secado: true,
      });
    } else {
      this.editControlForm.patchValue({
        presecado: false,
        secado: false,
      });
    }
  }
  comprobarCarretes(value) {
    if (value.checked) {
      this.editControlForm.patchValue({
        carretes_pequenos: true,
        carretes_grandes: true,
      });
    } else {
      this.editControlForm.patchValue({
        carretes_pequenos: false,
        carretes_grandes: false,
      });
    }
  }

  comprobarAutomaticas(value) {
    if (value.checked) {
      this.editControlForm.patchValue({
        automatica1: true,
        automatica2: true,
        automatica3: true,
        automatica4: true,
      });
    } else {
      this.editControlForm.patchValue({
        automatica1: false,
        automatica2: false,
        automatica3: false,
        automatica4: false,
      });
    }
  }

  comprobarCamaras(value) {
    if (value.checked) {
      this.editControlForm.patchValue({
        camara1: true,
        camara2: true,
        camara3: true,
        camara4: true,
      });
    } else {
      this.editControlForm.patchValue({
        camara1: false,
        camara2: false,
        camara3: false,
        camara4: false,
      });
    }
  }
  comprobarZonas(value) {
    if (value.checked) {
      this.editControlForm.patchValue({
        zona1: true,
        zona2: true,
        zona3: true,
        zona4: true,
        zona5: true,
        zona6: true,
        zona7: true,
        zona8: true,
        zona9: true,
      });
    } else {
      this.editControlForm.patchValue({
        zona1: false,
        zona2: false,
        zona3: false,
        zona4: false,
        zona5: false,
        zona6: false,
        zona7: false,
        zona8: false,
        zona9: false,
      });
    }
  }
}
